App.prototype.buildCart = function (cart) {
    var products = _.valuesIn(cart.products);
    var cartTotal = cart.total;
    var deliveryPrice = cart.delivery_price;
    var payment_method_price = cart.payment_method_price;
    var interest_price = cart.interest_price;
    var discounts = cart.discounts;
    var discount_texts = cart.discount_texts;
    var productBox = '';
    var is_in_iframe= window.self !== window.top;
    // console.log(products)

    products.forEach(function (product, key) {
        var image = '';
        if (product.product.image) {
            image = "<figure><a href='" + product.product.url + "'><img src=" + product.product.image.url + "></a></figure>";
        }
        var featuresText = '';
        if (product.features_text !== "") {
            featuresText = '<a href="javascript:;" class="tooltip-icon" data-toggle="tooltip" data-placement="top" title="' + product.features_text + '">i</a>';
        }
        var orderInputText = '';
        if (product.order_inputs_text !== "") {
            orderInputText = '<a href="javascript:;" class="tooltip-icon" data-toggle="tooltip" data-placement="top" title="' + product.order_inputs_text + '">?</a>';
        }
        var discountText = '';
        if (typeof product.discount_texts !== 'undefined' && product.discount_texts.length) {
            discountText = `<span class="badge badge-success">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                     stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-tag">
                    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
                    <line x1="7" y1="7" x2="7.01" y2="7"></line>
                </svg>
                ${product.discount_texts.join(', ')}
            </span>`;
        }

        var priceDisplay = '';

        if (cart.tax_excluded_basket) {
            priceDisplay = `${App.prototype.currencyFormat(product.price_without_tax)}${translates.currency_code} x ${product.quantity} = `;

            if (product.discount_amount_without_tax > 0) {
                priceDisplay += `<span class="basket-product-total-before-discount">${App.prototype.currencyFormat(product.total_before_discount_without_tax)}${translates.currency_code}</span>`;
            }

            priceDisplay += `<span class="basket-product-total">${App.prototype.currencyFormat(product.total_without_tax)}${translates.currency_code}</span>`;

            if (product.tax_rate > 0) {
                priceDisplay += `<br><small>${translates.tax_amount} (${product.tax_rate}%): ${App.prototype.currencyFormat(product.tax_amount)}${translates.currency_code}</small>`;
            }
        } else {
            priceDisplay = `${App.prototype.currencyFormat(product.price)}${translates.currency_code} x ${product.quantity} =`;
            priceDisplay += `
                <span class="basket-product-total-before-discount">${product.discount_total > 0 ? App.prototype.currencyFormat(product.total_before_discount) + '' + translates.currency_code : ''}</span>
                <span class="basket-product-total">${App.prototype.currencyFormat(product.total)}${translates.currency_code}</span>
            `;
        }

        productBox += `
            <div class="product-box" data-product_hash="${product.product_hash}" data-product_unique_id="${product.product.unique_id}">
                <div class="name"><a href="${product.product.url}">${product.product.name}${featuresText}${orderInputText}</a></div>
                <div class="details">
                    ${image}
                    <div class="infos">
                        <div class="sum">
                            ${priceDisplay}
                        </div>
                        ${typeof product.message !== 'undefined' ? '<small style="color:red">' + product.message + '</small>' : ''}
                        ${discountText}
                    </div>
                    <div class="counter">
                        <button type="button" class="decrease" ${is_in_iframe && product.quantity === 1 ? 'disabled' : ''}>
                            <svg width="10px" height="2px" viewBox="0 0 10 2" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g id="Page-1" stroke="none" stroke-width="1" fill="var(--button-text-color)" fill-rule="evenodd">
                                    <g id="Anasayfa-Vitrin" transform="translate(-464.000000, -985.000000)" fill="var(--button-text-color)" fill-rule="nonzero">
                                        <path d="M473.166653,985.166653 L469.833347,985.166653 L468.166653,985.166653 L464.833347,985.166653 C464.372506,985.166653 464,985.539999 464,986 C464,986.460001 464.372506,986.833347 464.833347,986.833347 L468.166653,986.833347 L469.833347,986.833347 L473.166653,986.833347 C473.627494,986.833347 474,986.460001 474,986 C474,985.539999 473.627494,985.166653 473.166653,985.166653 Z" id="Path"></path>
                                    </g>
                                </g>
                            </svg>
                        </button>
                        <input type="number" class="count form-control" value="${product.quantity}">
                        <button type="button" class="increase">
                            <svg width="10px" height="10px" viewBox="0 0 10 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g id="Page-1" stroke="none" stroke-width="1" fill="var(--button-text-color)" fill-rule="evenodd">
                                    <g id="Anasayfa" transform="translate(-951.000000, -792.000000)" fill="var(--button-text-color)" fill-rule="nonzero">
                                        <g id="interface" transform="translate(951.000000, 792.000000)">
                                            <path d="M9.16665266,4.16665266 L5.83334734,4.16665266 L5.83334734,0.833347342 C5.83334734,0.373346333 5.4608415,0 5,0 C4.5391585,0 4.16665266,0.373346333 4.16665266,0.833347342 L4.16665266,4.16665266 L0.833347342,4.16665266 C0.372505841,4.16665266 0,4.53999899 0,5 C0,5.46000101 0.372505841,5.83334734 0.833347342,5.83334734 L4.16665266,5.83334734 L4.16665266,9.16665266 C4.16665266,9.62665367 4.5391585,10 5,10 C5.4608415,10 5.83334734,9.62665367 5.83334734,9.16665266 L5.83334734,5.83334734 L9.16665266,5.83334734 C9.62749416,5.83334734 10,5.46000101 10,5 C10,4.53999899 9.62749416,4.16665266 9.16665266,4.16665266 Z" id="Path"></path>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>`;
    });

    var payment_method_price_html = '';

    if (payment_method_price != null){

        payment_method_price_html = '<tr>\n' +
            '                              <td>' + translates.payment_method_price + '</td>\n' +
            '                              <td align="right">' + App.prototype.currencyFormat(payment_method_price) + '' + translates.currency_code + '</td>\n' +
            '                          </tr>';

    }

    var discount_html = '';

    if (discounts.length){

        for (const discount_text in discount_texts) {

            discount_html += `<tr>
                              <td>${discount_text}</td>
                              <td align="right">-${App.prototype.currencyFormat(discount_texts[discount_text])}${translates.currency_code}</td>
                          </tr>`;
        }

    }

    var interest_price_html = '';

    if (interest_price != 0){

        interest_price_html = '<tr>\n' +
            '                              <td>' + translates.interest_price + '</td>\n' +
            '                              <td align="right">' + App.prototype.currencyFormat(interest_price) + '' + translates.currency_code + '</td>\n' +
            '                          </tr>';

    }

    // Add tax summary section for tax-excluded baskets
    var taxSummaryHtml = '';
    if (cart.tax_excluded_basket) {
        taxSummaryHtml = `
            <tr>
                <td>${translates.subtotal_without_tax}</td>
                <td align="right">${App.prototype.currencyFormat(cart.products_total_without_tax)}${translates.currency_code}</td>
            </tr>
            <tr>
                <td>${translates.tax_amount}</td>
                <td align="right">${App.prototype.currencyFormat(cart.total_tax_amount)}${translates.currency_code}</td>
            </tr>
        `;
    }

    var cartHtml = '<div class="cart-items">' + productBox + '</div>\n' +
        '                      <table>\n' +
        '                          <tbody>' +
        '' + taxSummaryHtml +
        '<tr>\n' +
        '                              <td>' + translates.delivery_price + '</td>\n' +
        '                              <td align="right">' + App.prototype.currencyFormat(deliveryPrice) + '' + translates.currency_code + '</td>\n' +
        '                          </tr>\n' + discount_html + '\n' + payment_method_price_html + '\n' + interest_price_html +
        '                          <tr class="total">\n' +
        '                              <td>' + translates.total + ':</td>\n' +
        '                              <td align="right">' + App.prototype.currencyFormat(cartTotal) + '' + translates.currency_code + '</td>\n' +
        '                          </tr>\n' +
        '                      </tbody></table>' +
        '<a href="/basket" class="btn btn-default btn-lg btn-block mt-3">' + translates.complete_order + '</a>'

    if (products.length > 0) {
        $('.sidebar-cart-wrapper').html(cartHtml);
    } else {
        $('.sidebar-cart-wrapper').html('<div class="empty-cart-alert">\n' +
            '                                <i class="ksicon empty-cart"></i>\n' +
            '                                <h4>' + translates.empty_cart + '</h4>\n' +
            '                                <p>' + translates.cart_slogan + '</p>\n' +
            '                            </div>');
    }

    var productsTotal = cart.total_quantity;
    $('[data-cart-sum]').text(cart.total_readable);
    $('[data-cart-count]').text(productsTotal);
    $('.site-header .header-cart-icon span').text(productsTotal);
    $('.mobile-bottom-menu .product-count').text(productsTotal);
    $('[data-toggle="tooltip"]').tooltip();

    if (productsTotal){
        $('.mobile-bottom-menu .basket').addClass("filled");
    }else{
        $('.mobile-bottom-menu .basket').removeClass("filled");
    }

    $.publish('/sticky-sidebar/update');
/*
    if (location.pathname === '/basket' && !products.length) {
        location.href = '/';
    }*/

};
